import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import PotmUserVotesModel from "./PotmUserVotesModel";

export default class PotmUserVotesResponseModel {
  public meta: MetaModel = new MetaModel();
  public data: PotmUserVotesModel[] = [];
}
